import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent {

  @Input() textAreaClass:string='form-control text-dark fw-normal fst-italic';

  @Input() textAreaLabel: string='';

  @Input() labelClass:string='data-label';

  @Input() textareaPlaceholder:string='';
  
  @Input() fieldValue: any;

  @Input() fieldText: string="";

  @Input() fControl:FormControl | any;

  @Input() isRequired:boolean=true;

  @Input() isDisable : boolean=false;

  @Input() patternValidationMsg: string = "";

  @Input() maxValueValidationMsg: string = "";

  @Input() minValueValidationMsg: string = "";

  @Input() maxLengthValidationMsg: string = "";

  @Input() minLengthValidationMsg: string = "";

  @Input() customErrorValidationMsg: string = "";

  @Output()
  onTextChange = new EventEmitter<any>();
  
  sendData(){
    this.fieldValue = this.fControl.value;
    this.onTextChange.emit({text:this.fieldText,value:this.fieldValue});
  }
}
